import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {MaterialModule} from '@modules/material/material.module';
import {AgmCoreModule} from '@agm/core';
import {TranslateModule} from '@ngx-translate/core';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {SharedModule} from '@modules/shared/shared.module';
import { AddressBookRoutingModule } from './address-book-routing.module';
import { AddressBookComponent } from './address-book.component';
import { AddressEditComponent } from './address-edit/address-edit.component';
import { ImportComponent } from '@modules/address-book/import/import.component';
import { ImportService } from '@services/import.service';

@NgModule({
  imports: [
    // angular
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    // libraries
    MaterialModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDL4eB6J10hcVcClWa-UrjvvqBAbMNIujo',
      libraries: ['places']
    }),
    TranslateModule,
    FontAwesomeModule,
    // custom
    SharedModule,
    AddressBookRoutingModule
  ],
  providers: [
    // FontAwesomeService
    ImportService
  ],
  declarations: [
    // components
    AddressBookComponent,
    AddressEditComponent,
    ImportComponent
  ],
  exports: [
    AddressBookComponent,
  ]
})

export class AddressBookModule {}



// WEBPACK FOOTER //
// ./src/app/modules/address-book/address-book.module.ts